import { Project } from 'src/store/state/projects';

const encoder = new TextEncoder();

export const calculateCsvSize = (contents: string) => {
  return encoder.encode(contents).length;
};

/**
 * Used to calculate the rough size of a project by summing up the file upload
 * contents. Note that the actual size stored on cloud is different because of
 * encodeCloudStorageProject(), but a rough estimate is used here.
 */

export const calculateProjectSize = (project?: Project) => {
  if (!project) {
    return 0;
  }

  return Object.values(project.fileUploadsById).reduce(
    (acc, fileUpload) => acc + calculateCsvSize(fileUpload.contents),
    0
  );
};
